import { cn } from '@eliadmin/core/src/utils/style-utils';

interface HeadingProps {
  title: string;
  as?: 'h1' | 'h2';
  className?: {
    container?: string;
    title?: string;
    line?: string;
  };
}

export function Heading({ title, className, as: Tag = 'h2' }: HeadingProps) {
  return (
    <div className={cn('flex items-center justify-start gap-6', className?.container)}>
      <Tag
        data-ea-visual-tag={Tag === 'h1' ? 'h2' : undefined}
        className={cn(
          'text-3xl font-normal tracking-tighter sm:text-4xl lg:text-5xl xl:text-6xl',
          className?.title,
        )}
      >
        {title}
      </Tag>
      <div className={cn('h-[2px] w-10 bg-black sm:w-12 md:w-16 lg:w-20', className?.line)} />
    </div>
  );
}
